/**
 * REWE Digital GmbH.
 * IT-Verticals
 * zr-energy-label - energy efficiency class
 */

@use "../zr-css-icon/zr-css-icon.scss" as i;
@import "../zr-theme/zr-theme";

$component: 'zr-eec';

:host {
    --zr-eec-font-size: var(--ci-font-size) + px;
    --energy-label-size: 20px;
}

.#{$component} {
    display: flex;
    font-size: var(--zr-eec-font-size);
    align-items: baseline;
}

.#{$component}__level {
    height: var(--energy-label-size);
    width: var(--energy-label-size);
    background-color: var(--ci-neutral400);
    text-decoration: none;

    span {
        transition: transform .25s;
        display: block;
        text-align: center;
        color: var(--ci-neutral100);
        background-color: var(--ci-neutral600);
        font-weight: 800;
        line-height: var(--energy-label-size);
    }

    .is-level {
        &-A {background-color: #00a653;}
        &-B {background-color: #50b94a;}
        &-C {background-color: #c1d831;}
        &-D {background-color: #fef100;}
        &-E {background-color: #feb712;}
        &-F {background-color: #f3701f;}
        &-G {background-color: #ee1b24;}
    }

    &:active,
    &:visited,
    &:focus,
    &:hover {
        text-decoration: none;
        color: var(--ci-neutral100);
    }

    &:hover {
        transform: scale(1.2);
    }
}

.#{$component}__link {
    @include i.get-icon-right(popup);

    margin: 0 0 0 5px;

    &::after {
        vertical-align: middle;
        top: -1px;
        position: relative;
        height: 18px;
        width: 18px;
    }

    &,
    &:active,
    &:visited,
    &:focus,
    &:hover {
        color: var(--ci-neutral600);
    }
}
